<template>
    <section>
        <PageTitle title="All Incoming Calls" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/callHistory',title:'call history'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Incoming Calls</h5>
                    </div>
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Warehouse</label>
                                    <multiselect v-model="selectedRestaurant" :options="restaurants" track-by="name" label="name"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Caller Name</label>
                                    <input v-model="callerName" placeholder="Caller Name..." class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Phone No.</label>
                                    <input v-model="callerNum" placeholder="Phone No..." class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Date Range</label>
                                    <input v-model="dateRange" type="text" readonly="readonly" placeholder="Search By Date Range" class="form-control date_picker"/>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_callHistory_btn"><i class="fa fa-search"></i> Search</button>
                                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_callHistory_btn"><i class="fa fa-refresh"></i> Refresh</button>
                            </div>
                        </div>
                        <hr/>

                        <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                                <thead>
                                    <tr>
                                        <th>Call ID</th>
                                        <th>Caller Name</th>
                                        <th>Contact Number</th>
                                        <th>Vendor</th>
                                        <th>Created</th>
                                        <th>Modified</th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import Multiselect from 'vue-multiselect'
    import moment from "moment/moment";

    export default {
        name: "CallHistory",
        components: {
            PageTitle,
            Multiselect
        },
        data() {
            return {
                selectedRestaurant:'',
                restaurants:[],
                callerName:'',
                callerNum:'',
                dateRange:''
            }
        },
        created: function(){
            this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                this.restaurants = resp.data;
            });
        },
        mounted: function (){
            let self = this;
            let processingURL = this.$store.state.mainAppURL + "call_history/get_all_calls";
            let dtTable = $('#dtTable').DataTable({
                "processing": true,
                "serverSide": true,
                autoWidth: false,
                "dom": 'lrtip',
                "order": [[0, "desc"]],
                "pagingType": "simple",
                "lengthMenu": [10, 25, 50, 100, 250],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(dtTable);
                      }
                    }
                },
                "columnDefs": [
                    { "orderable": false, "targets": [1,2,3,4] },
                    { 'className': "text-center", 'aTargets': [0,1,2,3,4,5]},
                ],
                "columns": [
                    { "data": "id", "name":"id" },
                    { "data": "customerName","name":"customer_name" },
                    { "data": "contactNo","name":"contact_no" },
                    {"data": "restaurantsByRestaurantId.name","name":"restaurant_name"},

                    {
                        "data": "created",
                        "name":"created",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "modified",
                        "name":"modified",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                ],
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip();
                },
                // "dom": 'lTfigt',
                "tableTools": {
                    "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                }
            });
            $.fn.dataTable.ext.errMode = 'none';
            $(".search_filter_callHistory_btn").click(function(){
                self.callerName!=='' && (dtTable.column(1).search( self.callerName ));
                self.callerNum!=='' && (dtTable.column(2).search( self.callerNum ));
                self.selectedRestaurant!=='' && (dtTable.column(3).search( self.selectedRestaurant.id ));
                self.dateRange!=='' && (dtTable.column(4).search( self.dateRange ));
                dtTable.draw();
            });
            $(".refresh_filter_callHistory_btn").click(function(){
                for(var i=1; i <= 4; i++){
                    dtTable.column(i).search( '' );
                }
                self.selectedRestaurant = "";
                self.callerName = "";
                self.callerNum = "";
                self.dateRange = "";
                dtTable.draw();
            });
            let dtTableFilterSelector = $("#dtTable_filter input");
            dtTableFilterSelector.unbind();
            dtTableFilterSelector.attr("size","35");
            dtTableFilterSelector.attr("placeholder", "Search On Name ,Phone No. or Warehouse Name....");
            dtTableFilterSelector.keyup(function (e) {
                if(e.keyCode === 13) {
                    dtTable.search($(this).val()).draw();
                }
            });
            $('.date_picker').daterangepicker({
                format: 'YYYY-MM-DD',
              maxDate: new Date,
              minDate: moment().subtract(3,'M')
            }).on('apply.daterangepicker', function(ev, picker) {
                self.dateRange = (picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
            }).on('cancel.daterangepicker', function(ev, picker) {
                self.dateRange = '';
            });
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
